// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"

/**
 * カスタムTurbo Streamアクション: redirect
 *
 * Turbo Streamsでリダイレクトを実行するためのカスタムアクション
 *
 * 使用例（コントローラー側）:
 *   render turbo_stream: turbo_stream.action(:redirect, some_path)
 *
 * this.target: リダイレクト先のURL
 */
Turbo.StreamActions.redirect = function () {
  Turbo.visit(this.target);
};
